// Notion Service - Fetches team member data from backend server

/**
 * Fetches all team members from the backend API (which calls Notion)
 * @returns {Promise<Array>} Array of team member objects
 */
export async function fetchTeamMembers() {
  try {
    const response = await fetch('/api/team-members');
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const teamMembers = await response.json();
    console.log(teamMembers);
    return teamMembers;

  } catch (error) {
    console.error('Error fetching team members from backend:', error);
    // Return empty array on error to prevent app from breaking
    return [];
  }
}

/**
 * Test function to verify backend connection
 */
export async function testNotionConnection() {
  try {
    const members = await fetchTeamMembers();
    if (members.length > 0) {
      console.log('✅ Backend connection successful!');
      console.log(`Found ${members.length} team members`);
      return true;
    } else {
      console.log('⚠️ Connection successful but no members found');
      return false;
    }
  } catch (error) {
    console.error('❌ Backend connection failed:', error.message);
    return false;
  }
}
